import i18n from '../../locales/index'
import editor from './editor'
import sms_note from './sms_note'
import sms_charge from './sms_charge'
import charge_coupon from './charge_coupon'
import lcsw_account from './lcsw_account'
import order from './order'
import bill from './bill'
import users_shop from './users_shop'
import supplier from './supplier'
import dashboard from './dashboard'
import customer from './customer'
import setting from './setting'
import message from './message'
import wechat_config from './wechat_config'
import category from './category'
import product from './product'
import shop from './shop'
import stock from './stock'
import water from './water'
import unit from './unit'
import depot from './depot'
import booking_store_product from './booking_store_product'
import booking from './booking'
import warehouse from './warehouse'
import breakage from './breakage'
import banner from './banner'
import material from './material'
import mall_property_name from './mall_property_name';
import mall_property_value from './mall_property_value';
import mall_product from './mall_product';
import mall_sku from './mall_sku';
import mall_category from './mall_category';
import mall_order from './mall_order';
import role from './role';
import permission from './permission';
import pkg from './package';
import bar_code from './bar_code';
import score_product from './score_product';
import score_product_change_record from './score_product_change_record';
import version from './versions';
import area from './area';
import customer_level from './customer_level';
import keyboard_shortcut from './keyboard_shortcut';
import enough_consume_discount from './enough_consume_discount';
import limited_time_activity from './limited_time_activity';
import combo from './combo';
import wxa_wechat from './wxa_wechat';
import oem from './oem';
import mall_group from './mall_group'
import printer_config from './printer_config'
import city_shop_freight from './city_shop_freight'
import desk_partition from './desk_partition'
import desk from './desk'
import seat from './seat'
import ai from './ai'
import ai_image from './ai_image'
import shop_charge from './shop_charge'
import function_payment from './function_payment'
import schedule_display_product from './schedule_display_product'
import score_reward from './score_reward'
import deduct_coupon_rule from './deduct_coupon_rule'
import deduct_coupon from './deduct_coupon'
import seckill from './seckill'
import delivery_setting from './delivery_setting'
import product_unit_switch from './product_switch'
import fresh_software_version from './fresh_software_version'
import balance_transaction from './balance_transaction'
import promote_company from './promote_company'
import promote_company_staff from './promote_company_staff'
import company_rebate_record from './company_rebate_record'
import staff_rebate_record from './staff_rebate_record'
import rebate_order_record from './rebate_order_record'
import country_timezone from './country_timezone'
import country_currency from './country_currency'
import tax from './tax.js'

export default {
  tax,
  area,
  customer,
  banner,
  material,
  editor,
  setting,
  category,
  city_shop_freight,
  message,
  wechat_config,
  sms_note,
  product,
  dashboard,
  charge_coupon,
  shop,
  sms_charge,
  lcsw_account,
  order,
  bill,
  supplier,
  users_shop,
  stock,
  water,
  unit,
  depot,
  booking_store_product,
  booking,
  breakage,
  warehouse,
  mall_category,
  mall_property_name,
  mall_property_value,
  mall_product,
  mall_sku,
  mall_order,
  role,
  permission,
  package: pkg,
  bar_code,
  score_product,
  score_product_change_record,
  version,
  customer_level,
  keyboard_shortcut,
  enough_consume_discount,
  combo,
  limited_time_activity,
  wxa_wechat,
  oem,
  mall_group,
  printer_config,
  desk_partition,
  desk,
  seat,
  ai,
  ai_image,
  shop_charge,
  function_payment,
  schedule_display_product,
  score_reward,
  deduct_coupon_rule,
  deduct_coupon,
  seckill,
  delivery_setting,
  product_unit_switch,
  fresh_software_version,
  balance_transaction,
  promote_company,
  promote_company_staff,
  company_rebate_record,
  staff_rebate_record,
  rebate_order_record,
  country_timezone,
  country_currency
}
